/**
 * Organization-level entity configuration types.
 *
 * Independent axes of per-org config:
 *
 * 1. Active field groups (global per org) — stored as a single document:
 *    org/{orgId}/config-entity/active-groups
 *
 * 2. Repository overrides (per entity) — stored as one document per entity:
 *    org/{orgId}/config-repository/{entityName}
 *    (same path as dev3; already read by repositoryResolver)
 *
 * 3. Field-audit retention overrides (per aggregate) — single document:
 *    org/{orgId}/config-entity/audit-retention
 */
export const ORG_ACTIVE_GROUPS = 'OrgActiveGroups';
export const ORG_REPOSITORY_CONFIG = 'OrgRepositoryConfig';
export const ORG_AUDIT_RETENTION = 'OrgAuditRetention';
//# sourceMappingURL=orgEntityConfig.js.map